'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _handlers = require('q/js/handlers');

var _debug = require('conversations-lib/debug');

var _WidgetUi = require('conversations-schema/records/WidgetUi');

var _WidgetUi2 = _interopRequireDefault(_WidgetUi);

var _ClientData = require('conversations-schema/records/ClientData');

var _ClientData2 = _interopRequireDefault(_ClientData);

var _setNewRelicErrorHandler = require('./error-reporting/lib/setNewRelicErrorHandler');

var _makeUsageTracker = require('./usage-tracking/factories/makeUsageTracker');

var _buildStore = require('./buildStore');

var _buildStore2 = _interopRequireDefault(_buildStore);

var _ApplicationContainer = require('./containers/ApplicationContainer');

var _ApplicationContainer2 = _interopRequireDefault(_ApplicationContainer);

var _AsyncMessagesPreview = require('./code-splitting/components/AsyncMessagesPreview');

var _AsyncMessagesPreview2 = _interopRequireDefault(_AsyncMessagesPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Application = function () {
  function Application() {
    _classCallCheck(this, Application);

    this.widgetShellUrl = new _hubspotUrlinator2.default(window.location);
  }

  _createClass(Application, [{
    key: 'getQueryParam',
    value: function getQueryParam(param) {
      return this.widgetShellUrl.paramValue(param);
    }
  }, {
    key: 'getMessagesUtk',
    value: function getMessagesUtk() {
      var path = this.widgetShellUrl.pathname;

      var utkIndex = path.indexOf('/utk/');

      var messagesUtkPathValue = path.slice(utkIndex).split('/').pop();

      var shouldUsePathValue = messagesUtkPathValue !== 'null' && utkIndex !== -1;

      return shouldUsePathValue ? messagesUtkPathValue : this.getQueryParam('messagesUtk');
    }
  }, {
    key: 'startRedux',
    value: function startRedux() {
      var messagesUtk = this.getMessagesUtk();

      this.store = (0, _buildStore2.default)({
        clientData: new _ClientData2.default({ isAdmin: false }),
        prospectUtks: { messagesUtk: messagesUtk },
        tracker: (0, _makeUsageTracker.makeUsageTracker)({
          messagesUtk: messagesUtk,
          inApp53: this.getQueryParam('inApp53') === 'true'
        }),
        iframeUuid: this.getQueryParam('uuid'),
        widgetUi: (0, _WidgetUi2.default)({
          mobile: this.getQueryParam('mobile') === 'true',
          open: this.getQueryParam('open') === 'true',
          hideWelcomeMessage: this.getQueryParam('hideWelcomeMessage') === 'true',
          domain: this.getQueryParam('domain'),
          url: decodeURIComponent(this.getQueryParam('url'))
        })
      });

      (0, _debug.setupDebug)(this.store);
      (0, _setNewRelicErrorHandler.setNewRelicErrorHandler)();
    }
  }, {
    key: 'renderWidget',
    value: function renderWidget() {
      var inline = this.getQueryParam('inline') === 'true';

      (0, _reactDom.render)(_react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        _react2.default.createElement(_ApplicationContainer2.default, { location: window.location, inline: inline })
      ), document.getElementsByClassName('widget')[0]);
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      (0, _reactDom.render)(_react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        _react2.default.createElement(_AsyncMessagesPreview2.default, {
          location: window.location,
          messageId: this.getQueryParam('messageId'),
          messagesUtk: this.getMessagesUtk()
        })
      ), document.getElementsByClassName('widget')[0]);
    }
  }, {
    key: 'start',
    value: function start() {
      window.AppInstance = this;
      (0, _handlers.logQPromiseIssuesAndSendAlerts)();
      _hubspot2.default.get();

      this.startRedux();

      if (this.getQueryParam('preview') === 'true') {
        this.renderPreview();
      } else {
        this.renderWidget();
      }
    }
  }]);

  return Application;
}();

exports.default = Application;


var app = new Application();

app.start();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/Application.js
// module id = 1216
// module chunks = 3